import React from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, 
  ModalBody, ModalCloseButton, VStack, Box, Text, Input, Textarea, 
  Button, Flex, Icon
} from "@chakra-ui/react";
import { FaEdit, FaCheckCircle } from "react-icons/fa";

const CustomContextModal = ({
  isOpen,
  onClose,
  newCustomContextName,
  setNewCustomContextName,
  newCustomContext,
  setNewCustomContext,
  handleAddCustomContext,
  secondaryColor,
  borderColor
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay backdropFilter="blur(2px)" />
      <ModalContent borderRadius="xl">
        <ModalHeader 
          bg={secondaryColor} 
          color="white" 
          borderTopRadius="xl"
          pb={6}
        >
          <Flex align="center">
            <Icon as={FaEdit} mr={2} />
            Create Custom Context
          </Flex>
        </ModalHeader>
        <ModalCloseButton color="white" />
        
        <ModalBody py={6}>
          <VStack spacing={4} align="stretch">
            <Box>
              <Text mb={2} fontWeight="medium">Context Name</Text>
              <Input
                value={newCustomContextName}
                onChange={(e) => setNewCustomContextName(e.target.value)}
                placeholder="e.g., Company Overview, Product Features"
                borderRadius="md"
              />
            </Box>
            
            <Box>
              <Text mb={2} fontWeight="medium">Context Content</Text>
              <Textarea
                value={newCustomContext}
                onChange={(e) => setNewCustomContext(e.target.value)}
                placeholder="Enter the text content for this custom context..."
                size="md"
                rows={10}
                borderRadius="md"
              />
              <Text fontSize="sm" color="gray.500" mt={2}>
                {newCustomContext.length} characters
              </Text>
            </Box>
          </VStack>
        </ModalBody>
        
        <ModalFooter 
          borderTop="1px" 
          borderTopColor={borderColor} 
          pt={4}
        >
          <Button 
            leftIcon={<FaCheckCircle />}
            colorScheme="purple" 
            mr={3} 
            onClick={handleAddCustomContext}
            isDisabled={!newCustomContextName.trim() || !newCustomContext.trim()}
            borderRadius="md"
          >
            Add Context
          </Button>
          <Button 
            variant="outline" 
            onClick={onClose}
            borderRadius="md"
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CustomContextModal;